import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function WhyItDidntWorkSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="w-full bg-warmWhite py-20 px-4" data-id="element-226">
      <div className="max-w-4xl mx-auto" data-id="element-227">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-228">
          <h2 className="font-heading text-3xl sm:text-4xl text-charcoal mb-4" data-id="element-229">
            Por qué lo que intentaste no funcionó
          </h2>
          <p className="font-body text-warmGray text-lg" data-id="element-230">
            Estos métodos populares tienen un problema fundamental
          </p>
        </motion.div>

        <motion.div className="space-y-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-231">
          <motion.div className="bg-cream rounded-2xl p-6 sm:p-8 border border-terracotta-100 shadow-warm" variants={itemVariants} data-id="element-232">
            <div className="flex items-start gap-4" data-id="element-233">
              <div className="flex-shrink-0 w-10 h-10 bg-red-50 rounded-full flex items-center justify-center" data-id="element-234">
                <XCircleIcon className="w-6 h-6 text-red-400" data-id="element-235" />
              </div>
              <div data-id="element-236">
                <h3 className="font-heading text-xl text-charcoal mb-2" data-id="element-237">
                  Dejarlo llorar ("Cry-it-out")
                </h3>
                <p className="font-body text-warmGray leading-relaxed" data-id="element-238">
                  Solo enseña al bebé que nadie vendrá, elevando su cortisol y
                  fragmentando su sueño a largo plazo.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div className="bg-cream rounded-2xl p-6 sm:p-8 border border-terracotta-100 shadow-warm" variants={itemVariants} data-id="element-239">
            <div className="flex items-start gap-4" data-id="element-240">
              <div className="flex-shrink-0 w-10 h-10 bg-red-50 rounded-full flex items-center justify-center" data-id="element-241">
                <XCircleIcon className="w-6 h-6 text-red-400" data-id="element-242" />
              </div>
              <div data-id="element-243">
                <h3 className="font-heading text-xl text-charcoal mb-2" data-id="element-244">
                  Mantenerlo despierto más tiempo
                </h3>
                <p className="font-body text-warmGray leading-relaxed" data-id="element-245">
                  Genera un exceso de adrenalina que hace casi imposible que
                  concilie el sueño profundo.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div className="bg-cream rounded-2xl p-6 sm:p-8 border border-terracotta-100 shadow-warm" variants={itemVariants} data-id="element-246">
            <div className="flex items-start gap-4" data-id="element-247">
              <div className="flex-shrink-0 w-10 h-10 bg-red-50 rounded-full flex items-center justify-center" data-id="element-248">
                <XCircleIcon className="w-6 h-6 text-red-400" data-id="element-249" />
              </div>
              <div data-id="element-250">
                <h3 className="font-heading text-xl text-charcoal mb-2" data-id="element-251">
                  Los consejos de internet
                </h3>
                <p className="font-body text-warmGray leading-relaxed" data-id="element-252">
                  Son contradictorios y no ofrecen un plan paso a paso diseñado
                  para la realidad de una madre primeriza agotada.
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}